import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Asleep"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.1172 4.05749C9.4224 7.0242 9.95406 10.1457 11.5917 12.7152C13.2294 15.2846 15.8345 17.0846 18.8172 17.7075C17.2462 19.3358 15.0797 20.2538 12.8172 20.25H12.5022C8.49405 20.1028 5.16067 17.1186 4.57263 13.1512C3.98458 9.1837 6.30906 5.36095 10.1022 4.05749H10.1172ZM11.2496 2.25H11.0996C6.1039 3.07781 2.55739 7.56949 2.911 12.621C3.2646 17.6725 7.40229 21.6263 12.4646 21.75H12.8321C16.0292 21.7519 19.0266 20.1958 20.8646 17.58C21.0194 17.3511 21.0357 17.0556 20.9072 16.811C20.7786 16.5664 20.5259 16.4123 20.2496 16.41C17.2164 16.1372 14.4818 14.4711 12.8485 11.9007C11.2151 9.3302 10.8682 6.14693 11.9096 3.285C12.0027 3.0591 11.9799 2.80201 11.8486 2.596C11.7172 2.39 11.4937 2.26089 11.2496 2.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Asleep.vue"]]);
